import styled from 'styled-components';
import { Badge, paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import { DynamicContent } from '../../../../../app-kit/components/DynamicContent/DynamicContent';
import {
  ButtonFragment,
  mapDynamicContentItems,
  TextFragment,
  WebLinkFragment,
} from '../../../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { BadgeVariant, mapBadgeVariant } from '../../../../../app-kit/helpers/mapBadgeVariant';
import { ConnectionQuality } from '../../InternetAvailabilityBrickV2';
import { ConnectionQualityGauge } from '../InternetConnectionQualityGauge/InternetConnectionQualityGauge';

const TitleText = styled(Text)`
  ${typographyHelper('subtitle01')};
  font-size: 1rem;
`;

const SubtitleText = styled(Text)`
  ${typographyHelper('subtitle02')};
  color: ${paletteHelper('textSecondary')};
`;

const StyledDynamicContentWrapper = styled.div`
  max-width: 36rem;
  line-height: 1.125rem;
`;

const StyledDynamicContent = styled(DynamicContent)`
  ${typographyHelper('body02')}
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
`;

interface InternetConnectionBrickProps {
  connection: {
    title: string;
    subtitle?: string | null;
    badge?: {
      text: string;
      variant: BadgeVariant;
    } | null;
    description: (WebLinkFragment | TextFragment | ButtonFragment)[];
    connectionQuality: ConnectionQuality | null;
  };
}

export const InternetConnectionBrick: FunctionComponent<InternetConnectionBrickProps> = ({
  connection,
}) => {
  const { title, subtitle, badge, description } = connection;

  return (
    <ContentBrick
      titleComponent={<TitleText as="h3">{title}</TitleText>}
      subtitleComponent={<SubtitleText>{subtitle}</SubtitleText>}
      subtitle={subtitle}
      isSubBrick={true}
      headerChildren={badge && <Badge variant={mapBadgeVariant(badge.variant)}>{badge.text}</Badge>}
    >
      <ContentWrapper>
        <StyledDynamicContentWrapper>
          <StyledDynamicContent
            dynamicContents={mapDynamicContentItems(description)}
            textColorVariant="textSecondary"
          />
        </StyledDynamicContentWrapper>
        {connection.connectionQuality && (
          <ConnectionQualityGauge connectionQuality={connection.connectionQuality} />
        )}
      </ContentWrapper>
    </ContentBrick>
  );
};
